import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import api from "../lib/api";

export const TickerTape = () => {
  const location = useLocation();
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    api.get("/ticker").then(({ data }) => setMessages(data.messages || [])).catch(() => {});
  }, []);

  if (location.pathname.startsWith("/admin") || messages.length === 0) return null;

  const content = messages.map((m) => m.text).join("      •      ");
  const duration = Math.max(18, Math.round(content.length / 4));

  return (
    <div className="bg-[#1A1A1A] text-[#E8DCC8] overflow-hidden relative z-50" data-testid="ticker-tape">
      <div className="ticker-track flex whitespace-nowrap py-2" style={{ animationDuration: `${duration}s` }}>
        <span className="text-[11px] tracking-[0.18em] uppercase font-semibold px-10" data-testid="ticker-tape-content">{content}</span>
        <span className="text-[11px] tracking-[0.18em] uppercase font-semibold px-10" aria-hidden="true">{content}</span>
      </div>
    </div>
  );
};
